import { useEffect, useRef } from 'react';

export const useDebounce = (callback: (...args: any[]) => unknown, delay = 300) => {
    const timeoutRef = useRef<number | null>(null);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (...args: any[]) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // @ts-expect-error -- setTimeout resolves to the Node typing (returns Timeout) while the ref stores the browser's numeric handle
        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};
